export default
  [
    {
      path: '',
      redirect: 'consignorUpdate'
    },
    // 货主APP管理
    {
      path: 'consignorUpdate', // 更新管理
      name: 'consignorUpdate',
      component: () => import('@/page/appManagementCenter/consignorUpdate'),
      meta: { openKeyName: '货主APP管理', selectKeyUrl: 'consignorUpdate' }
    },
    {
      path: 'consignorFeedback', // 意见反馈
      name: 'consignorFeedback',
      component: () => import('@/page/appManagementCenter/consignorFeedback'),
      meta: { openKeyName: '货主APP管理', selectKeyUrl: 'consignorFeedback' }
    },
    // 船主APP管理
    {
      path: 'shipOwnerUpdate', // 更新管理
      name: 'shipOwnerUpdate',
      component: () => import('@/page/appManagementCenter/shipOwnerUpdate'),
      meta: { openKeyName: '船主APP管理', selectKeyUrl: 'shipOwnerUpdate' }
    },
    {
      path: 'shipOwnerFeedback', // 意见反馈
      name: 'shipOwnerFeedback',
      component: () => import('@/page/appManagementCenter/shipOwnerFeedback'),
      meta: { openKeyName: '船主APP管理', selectKeyUrl: 'shipOwnerFeedback' }
    },
    // 监管APP管理
    {
      path: 'supervisorUpdate', // 更新管理
      name: 'supervisorUpdate',
      component: () => import('@/page/appManagementCenter/supervisorUpdate'),
      meta: { openKeyName: '监管APP管理', selectKeyUrl: 'supervisorUpdate' }
    },
    {
      path: 'supervisorFeedback', // 意见反馈
      name: 'supervisorFeedback',
      component: () => import('@/page/appManagementCenter/supervisorFeedback'),
      meta: { openKeyName: '监管APP管理', selectKeyUrl: 'supervisorFeedback' }
    },
    // 司机APP管理
    {
      path: 'driverUpdate', // 更新管理
      name: 'driverUpdate',
      component: () => import('@/page/appManagementCenter/driverUpdate'),
      meta: { openKeyName: '司机APP管理', selectKeyUrl: 'driverUpdate' }
    },
    {
      path: 'driverFeedback', // 意见反馈
      name: 'driverFeedback',
      component: () => import('@/page/appManagementCenter/driverFeedback'),
      meta: { openKeyName: '司机APP管理', selectKeyUrl: 'driverFeedback' }
    },
  ]



// WEBPACK FOOTER //
// ./src/router/appManagementCenter/index.js